module.exports = __webpack_public_path__ + "img/icon-scan-failed-underpaid.81e7ca2a.svg";